export enum LocalStoreType {
    email = "email",
    userData ="userData",
    isAdmin ="isAdmin",
    isWolf = "isWolf",
    canEditProfile = "canEditProfile",
    employeeId = "employeeId",
    nameTh ="nameTh",
    favorite="favorite"
  } 